export const toSentenceCase = (str) => {
  return str
    .toLowerCase()
    .replace(/\.(\S)/g, '. $1') // Adds space after full stops if not existing
    .replace('\n', '. ') // replaces new lines with a full stop and a space
    .split('. ')
    .map((sentence) => {
      const [firstLetter, ...rest] = sentence;
      return `${firstLetter?.toUpperCase()}${rest.join('')}`;
    })
    .join('. ')
    .replace('..', '.');
};
